import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography
} from '@mui/material';
import { Box } from '@mui/system';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Icon } from '@iconify/react';
import { useSelector } from 'react-redux';

export default function DialogSelectRoles({ selectedRoles, addRoles }) {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <Box>
      {/* <Button variant="contained" color="info" onClick={() => setOpenDialog(true)}>
        Abrir dialogo
      </Button> */}
      <IconButton color="info" onClick={() => setOpenDialog(true)}>
        <Icon icon="eva:plus-outline" />
      </IconButton>
      <DialogRoles open={openDialog} onClose={setOpenDialog} selectedRoles={selectedRoles} addRoles={addRoles} />
    </Box>
  );
}

function DialogRoles({ open, onClose, selectedRoles, addRoles }) {
  const [selectedRolesArr, setSelectedRolesArr] = useState([]);
  const [noSelectedRolesArr, setNoSelectedRolesArr] = useState([]);
  const { roles } = useSelector((state) => state.dagpacketRoles);
  const handleClose = () => {
    onClose(false);
  };

  const handleDelete = () => {
    console.info('You clicked the delete icon.');
  };

  const addRolesHandler = (idRol) => {
    addRoles(idRol);
    // console.log(idRol);
  };

  useEffect(() => {
    const selectedArr = [];
    const noSelectedArr = [];
    roles.map((generalRol) => {
      // console.log(generalRol);
      const rolObj = { id: generalRol.id };
      const includedRol = selectedRoles.includes(generalRol.id);

      if (includedRol) {
        rolObj.selected = true;
        selectedArr.push(rolObj);
      } else {
        rolObj.selected = false;
        noSelectedArr.push(rolObj);
      }

      return false;
    });
    // console.log('este es --------', newArr);
    setSelectedRolesArr(selectedArr);
    setNoSelectedRolesArr(noSelectedArr);
  }, [roles, selectedRoles]);
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Roles</DialogTitle>
      <DialogContent>
        <Card sx={{ padding: '15px' }}>
          <Typography>Roles selececcionados</Typography>
          <Divider />
          <Box sx={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '10px' }}>
            {selectedRolesArr.length ? (
              <>
                {selectedRolesArr.map((rol) => (
                  <Chip key={rol.id} label={rol.id} icon={<Icon icon="eva:checkmark-fill" />} />
                ))}
              </>
            ) : (
              <Typography>No hay roles seleccionados</Typography>
            )}
          </Box>
        </Card>

        <Card sx={{ padding: '15px', marginTop: '10px' }}>
          <Typography>Roles no selececcionados</Typography>
          <Divider />
          <Box sx={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '10px' }}>
            {noSelectedRolesArr.length ? (
              <>
                {noSelectedRolesArr.map((rol) => (
                  <Chip key={rol.id} label={rol.id} onClick={() => addRolesHandler(rol.id)} />
                ))}
              </>
            ) : (
              <Typography>No hay roles no seleccionados</Typography>
            )}
          </Box>
        </Card>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit" startIcon={<KeyboardBackspaceIcon />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
